import { render, staticRenderFns } from "./TwistMain.vue?vue&type=template&id=e3646bea&scoped=true&"
import script from "./TwistMain.vue?vue&type=script&lang=js&"
export * from "./TwistMain.vue?vue&type=script&lang=js&"
import style0 from "./TwistMain.vue?vue&type=style&index=0&id=e3646bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3646bea",
  null
  
)

/* custom blocks */
import block0 from "./TwistMain.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports